// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","2350":"d5ec7c15","4232":"d5ec7c15","4896":"d5ec7c15","6044":"d5ec7c15","6083":"93bf79fb","8084":"d5ec7c15"}[chunkId] + ".chunk.css";
};